<script>
import { mapState, mapActions } from 'vuex'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { VueGoodTable } from 'vue-good-table'
import { debounce } from 'vue-debounce'
import { SweetModal } from 'sweet-modal-vue'
import VuePdfApp from 'vue-pdf-app'
import vSelect from 'vue-select'
import PaginationCustom from '@/components/table/Pagination.vue'
import ScrapLogModal from '@/components/oss/ScrapLogModal.vue'
import ScrapConfigModal from '@/components/oss/ScrapConfigModal.vue'
// import appData from '@/data'

export default {
   name: 'ScrapSource',
   components: {
      BCardCode,
      VueGoodTable,
      PaginationCustom,
      ScrapLogModal,
      ScrapConfigModal,
      SweetModal,
      VuePdfApp,
      vSelect,
   },
   data() {
      return {
         pdf: '',
         loadingPdf: false,
         nib: '',
         loading: true,
         loadingRun: false,
         scrapLogVisible: false,
         scrapConfigVisible: false,
         scrapNib: '',
         file: null,
         serverParams: {
            columnFilters: {},
            sort: {
               field: '',
               type: '',
            },
            search: '',
            page: 1,
            perPage: 10,
            filter: {
               error: null,
               download: null,
               anomali: null,
            },
         },
         pageLength: 10,
         pageOptions: ['10', '25', '50', '100'],
         searchTerm: '',
         optionsErrorFilter: [
            { value: 1, text: 'Hanya Error' },
         ],
         optionsDownloadFilter: [
            { value: 1, text: 'Nib yang Belum di Download' },
         ],
         optionsAnomaliFilter: [
            { value: 1, text: 'KBLI di Sintang lebih banyak dari total KBLI' },
            { value: 2, text: 'KBLI di Sintang berjumlah 0' },
         ],
         isFilterOpen: false,
         columns: [
            {
               label: 'NIB / Nama',
               field: 'nib',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Skala / Email / Username',
               field: 'username',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'KBLI',
               field: 'kbli',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Terbit',
               field: 'tgl',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Terakhir Diupdate',
               field: 'updated_at',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Status',
               field: 'status',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Error',
               field: 'error',
               sortable: false,
               thClass: 'text-center align-middle',
            },
            {
               label: 'Action',
               field: 'action',
               sortable: false,
               thClass: 'text-center align-middle',
            },
         ],

      }
   },
   computed: {
      ...mapState({
         myData: state => state.OssScrap.items,
         myCount: state => state.OssScrap.countAll,
      }),
      statusNIBVariant() {
         return status => (status ? 'primary' : 'danger')
      },
      isLoading() {
         return this.$store.state.isLoading
      },
   },
   watch: {
      loadingPdf(val) {
         if (val) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()
         } else {
            this.$swal.close()
         }
      },
   },
   mounted() {
      this.loadItems()
   },
   methods: {
      ...mapActions({
         getData: 'OssScrap/getDataTable',
         runLogin: 'OssScrap/runLogin',
         storeNib: 'OssScrap/storeNib',
         importData: 'OssScrap/importData',
         clearError: 'OssScrap/clearError',
         nibDetele: 'OssScrap/nibDetele',
         resetData: 'OssScrap/resetData',
         cetakIzin: 'OssIzinRba/cetakIzin',
         cetakNib: 'OssNib/cetakNib',
         DownloadNib: 'OssScrapDownloadNib/runScrap',

      }),
      onRunScrap(nib) {
         this.scrapNib = nib
         this.scrapLogVisible = true
      },
      onScrapDone(nib) {
         this.clearError(nib).then(() => {
            this.loadItems()
         }, () => {
            this.loadItems()
         })
      },
      onDeteleNib(nib) {
         this.loadingRun = true
         this.nibDetele(nib).then(() => {
            this.loadingRun = false
            this.loadItems()
         }, () => {
            this.loadItems()
            this.loadingRun = false
         })
      },
      onResetData(nib) {
         this.$swal({
            title: 'Konfirmasi',
            text: `Apakah Anda yakin ingin mereset data NIB ${nib}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
         }).then(result => {
            if (result.value) {
               this.loadingRun = true
               this.$swal({ text: 'Loading', allowOutsideClick: false })
               this.$swal.showLoading()

               this.resetData(nib).then(() => {
                  this.$toast.success('Data berhasil di reset')
                  this.loadItems()
               }, () => {
                  this.$toast.error('Reset data gagal')
               }).finally(() => {
                  this.$swal.close()
                  this.loadingRun = false
               })
            }
         })
      },
      onAddItem() {
         this.$bvModal.show('modal-form')
      },
      onImport() {
         this.$bvModal.show('modal-import')
      },
      onLogin() {
         this.loadingRun = true
         this.$swal({ text: 'Loading', allowOutsideClick: false })
         this.$swal.showLoading()

         this.runLogin().then(() => {
            this.$toast.success('Login Berhasil')
         }, () => {
            this.$toast.error('Login Gagal')
         }).finally(() => {
            this.$swal.close()
            this.loadingRun = false
         })
      },
      onFilter() {
         this.serverParams.page = 1
         this.loadItems()
      },
      onShownCollapse() {
         this.isFilterOpen = true
         this.serverParams.page = 1
         this.loadItems()
      },
      onHiddenCollapse() {
         this.isFilterOpen = false
         this.serverParams.page = 1
         this.serverParams.filter.error = null
         this.serverParams.filter.download = null
         this.serverParams.filter.anomali = null
         this.loadItems()
      },
      onConfig() {
         this.scrapConfigVisible = true
      },
      onSaveNib() {
         this.$swal({ text: 'Loading', allowOutsideClick: false })
         this.$swal.showLoading()

         this.storeNib(this.nib.trim()).then(() => {
            this.nib = ''
            this.loadItems()
         }).finally(() => {
            this.$swal.close()
         })
      },
      onSave() {
         if (this.file) {
            this.$swal({ text: 'Loading', allowOutsideClick: false })
            this.$swal.showLoading()

            this.importData(this.file).then(() => {
               this.file = null
               this.loadItems()
               this.$bvModal.hide('modal-import')
            }, () => {
               this.$bvToast.toast('Import gagal', {
                  title: 'Error', variant: 'danger', solid: true,
               })
            }).finally(() => {
               this.$swal.close()
            })
         } else {
            this.$bvToast.toast('File Excel belum dipilih', {
               title: 'Error', variant: 'danger', solid: true,
            })
         }
      },
      onDownloadNib(idPermohonan, nib) {
         this.loadingRun = true
         const data = {
            id_permohonan: idPermohonan,
            nib,
         }

         this.$swal({ text: 'Loading', allowOutsideClick: false })
         this.$swal.showLoading()

         this.DownloadNib(data).then(() => {
            this.loadItems()
         }).finally(() => {
            this.$swal.close()
            this.loadingRun = false
         })
      },
      onCetakNib(nib) {
         this.loadingPdf = true
         this.cetakNib(nib).then(res => {
            const blob = new Blob([res.data])
            this.pdf = URL.createObjectURL(blob)
            // URL.revokeObjectURL(objectURL)
            this.$refs.modalPdf.open()
            this.loadingPdf = false
         }, () => {
            this.loadingPdf = false
         })
      },
      // VUE GOOD TABLE
      async loadItems() {
         this.loading = true
         await this.getData(this.serverParams)
      },
      updateParams(newProps) {
         // eslint-disable-next-line prefer-object-spread
         this.serverParams = Object.assign({}, this.serverParams, newProps)
      },
      onPageChangePagination(page) {
         this.updateParams({ page })
         this.loadItems()
      },
      onPerPageChangePagination(perPage) {
         this.updateParams({ perPage, page: 1 })
         this.loadItems()
      },
      onColumnFilter(params) {
         this.updateParams({ ...params, page: 1 })
         this.loadItems()
      },
      onSearch: debounce(function search(params) {
         this.serverParams.search = params
         this.serverParams.page = 1
         this.loadItems()
      }, 500),
      // onRowClick(params) {
      //    this.$router.push(`/oss/nib/${params.row.id_permohonan}`)
      // },
   },
}
</script>

<template>
   <div>
      <b-card-code title="Data Scrap Source">
         <b-row>
            <!-- TOOLBAR -->
            <b-col cols="12" md="6">
               <b-form @submit.stop.prevent>
                  <div class="d-flex align-items-center justify-content-end">
                     <b-form-input
                        v-model="searchTerm"
                        class="d-inline-block mb-1"
                        placeholder="Search..."
                        autocomplete="off"
                        type="text"
                        aria-label="Search"
                        @input="onSearch"
                     />
                  </div>
               </b-form>
            </b-col>
            <b-col cols="12" md="6">
               <div class="d-flex justify-content-end">
                  <b-button-group class="mb-1">
                     <b-button variant="outline-secondary" size="sm" @click="onAddItem()">
                        <feather-icon icon="PlusIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="onImport()">
                        <feather-icon icon="UploadIcon" />
                     </b-button>
                     <b-button
                        v-b-tooltip.hover.top="'Filter'"
                        v-b-toggle.collapse-filter
                        variant="outline-secondary"
                        size="sm"
                     >
                        <feather-icon icon="FilterIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="onConfig()">
                        <feather-icon icon="SettingsIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="onLogin()">
                        <feather-icon icon="LogInIcon" />
                     </b-button>
                     <b-button variant="outline-secondary" size="sm" @click="loadItems()">
                        <feather-icon icon="RefreshCwIcon" />
                     </b-button>
                     <b-dropdown variant="outline-secondary" right text="Menu" size="sm">
                        <b-dropdown-item @click="onAddItem()">
                           Tambah NIB
                        </b-dropdown-item>
                        <b-dropdown-item @click="onFilter()">
                           Filter
                        </b-dropdown-item>
                        <b-dropdown-item @click="onConfig()">
                           Konfigurasi
                        </b-dropdown-item>
                        <b-dropdown-item @click="onImport()">
                           Import
                        </b-dropdown-item>
                        <b-dropdown-item @click="onLogin()">
                           Login
                        </b-dropdown-item>
                        <b-dropdown-item @click="loadItems()">
                           Refresh
                        </b-dropdown-item>
                     </b-dropdown>
                  </b-button-group>
               </div>
            </b-col>
         </b-row>

         <!-- FILTER -->
         <b-row>
            <b-col>
               <b-collapse id="collapse-filter" class="mt-2" @shown="onShownCollapse" @hidden="onHiddenCollapse">
                  <b-card class="border">
                     <b-row>
                        <b-col md="4">
                           <b-form-group label="Menampilkan Error" label-for="filter-error">
                              <v-select
                                 id="filter-error"
                                 v-model="serverParams.filter.error"
                                 :options="optionsErrorFilter"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="4">
                           <b-form-group label="Menampilkan NIB" label-for="filter-download">
                              <v-select
                                 id="filter-download"
                                 v-model="serverParams.filter.download"
                                 :options="optionsDownloadFilter"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                        <b-col md="4">
                           <b-form-group label="Filter Anomali" label-for="filter-anomali">
                              <v-select
                                 id="filter-anomali"
                                 v-model="serverParams.filter.anomali"
                                 :options="optionsAnomaliFilter"
                                 :reduce="opt => opt.value"
                                 label="text"
                                 placeholder="Pilih..."
                                 :clearable="true"
                                 @input="onFilter"
                              />
                           </b-form-group>
                        </b-col>
                     </b-row>
                  </b-card>
               </b-collapse>
            </b-col>
         </b-row>
         <!-- FILTER -->

         <!-- search input -->

         <!-- table -->
         <vue-good-table
            ref="goodTable"
            mode="remote"
            :columns="columns"
            :rows="myData"
            :total-rows="myCount"
            :is-loading.sync="loading"
            :line-numbers="true"
            :pagination-options="{
               enabled: true,
               mode: 'pages',
            }"
            :search-options="{
               enabled: true,
               externalQuery: searchTerm,
            }"
            @on-column-filter="onColumnFilter"
            @on-search="onSearch"
         >
            <template slot="table-row" slot-scope="props">
               <!-- Column: Name -->
               <span v-if="props.column.field == 'tgl'">
                  <center>{{ props.row.tanggal_terbit_oss | moment("DD-MM-YYYY") }}</center>
               </span>

               <span v-if="props.column.field == 'updated_at'">
                  <center>{{ props.row.updated_at | moment("DD-MM-YYYY | HH:mm:ss") }}</center>
               </span>

               <span v-if="props.column.field == 'nib'">
                  <b>{{ (props.row.nama_perusahaan) }}</b>
                  <br>
                  <hr>
                  <b class="text-primary">{{ (props.row.nib) }}</b>
                  <hr>
                  <small>{{ props.row.uraian_jenis_nib }}</small>
                  <hr>
                  <small>{{ props.row.jenis_perusahaan_uraian }}</small>
               </span>

               <span v-if="props.column.field == 'username'">
                  <b class="text-primary">{{ (props.row.skala_usaha) }}</b>
                  <hr>
                  <small>
                     <b>{{ (props.row.username) }}</b>
                  </small>
                  <hr>
                  <small>{{ (props.row.email) }}</small>
               </span>
               <span v-if="props.column.field == 'status'">
                  <center>
                     <b-badge variant="dark">
                        <small>{{ (props.row.status_nib) }}</small>
                     </b-badge>
                  </center>
               </span>

               <span v-if="props.column.field == 'error'">
                  <center>
                     <b-badge v-if="props.row.message" variant="danger">
                        <small>Error</small>
                     </b-badge>
                     <hr>
                     <small>{{ (props.row.message) }}</small>
                  </center>
               </span>

               <span v-if="props.column.field == 'kbli'">
                  <div class="kbli-row">
                     <small class="text-muted">Di Sintang :</small>
                     <b>{{ (props.row.totalKbli) }}</b>
                  </div>
                  <hr>
                  <div class="kbli-row">
                     <small class="text-muted">Total KBLI :</small>
                     <b>{{ (props.row.kbli) }}</b>
                  </div>
               </span>

               <span v-if="props.column.field == 'action'">
                  <b-button size="sm" block variant="outline-dark" @click="onRunScrap(props.row.nib)">
                     <feather-icon icon="PlayIcon" class="mr-50" />
                     <small>Run Scrap</small>
                  </b-button>
                  <b-button
                     v-if="props.row.nib"
                     size="sm"
                     block
                     variant="outline-danger"
                     @click="onResetData(props.row.nib)"
                  >
                     <feather-icon icon="RotateCcwIcon" class="mr-50" />
                     <small>Reset</small>
                  </b-button>
                  <b-button
                     v-if="props.row.s3_path"
                     v-b-tooltip.hover.top="'Cetak NIB'"
                     size="sm"
                     block
                     variant="primary"
                     class="nowrap"
                     @click="onCetakNib(props.row.nib)"
                  >
                     <feather-icon icon="FileTextIcon" class="mr-50" />
                     <small>Cetak NIB</small>
                  </b-button>
                  <b-button
                     size="sm"
                     block
                     :variant="statusNIBVariant(props.row.s3_path)"
                     @click="onDownloadNib(props.row.permohonan_id, props.row.nib)"
                  >
                     <feather-icon icon="DownloadCloudIcon" class="mr-50" />
                     <small>Download NIB</small>
                  </b-button>
                  <b-button
                     v-if="!props.row.permohonan_id"
                     size="sm"
                     block
                     variant="outline-danger"
                     @click="onDeteleNib(props.row.nib)"
                  >
                     <feather-icon icon="Trash2" class="mr-50" />
                     <small>Delete NIB</small>
                  </b-button>

               </span>

               <!-- Column: Common -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
               <!-- <span v-else>{{ props.formattedRow[props.column.field] }}</span> -->
            </template>

            <!-- pagination -->
            <template slot="pagination-bottom" slot-scope="props">
               <pagination-custom
                  :total="props.total"
                  :page-length="pageLength"
                  :page-options="pageOptions"
                  :page="serverParams.page"
                  :page-changed="props.pageChanged"
                  :per-page-changed="props.perPageChanged"
                  @update:page="onPageChangePagination"
                  @update:perpage="onPerPageChangePagination"
               />
            </template>
         </vue-good-table>
      </b-card-code>

      <b-modal
         id="modal-form"
         cancel-variant="outline-secondary"
         ok-title="Simpan"
         cancel-title="Close"
         centered
         title="Form"
         @ok="onSaveNib"
      >
         <b-form>
            <b-form-group>
               <label for="nib">NIB:</label>
               <b-form-input id="nib" v-model="nib" type="text" placeholder />
            </b-form-group>
         </b-form>
      </b-modal>

      <b-modal
         id="modal-import"
         scrollable
         size="lg"
         centered
         hide-footer
         title="Form Import"
         no-close-on-backdrop
      >
         <b-form-group label="File Excel">
            <b-form-file
               v-model="file"
               placeholder="Choose a file or drop it here..."
               drop-placeholder="Drop file here..."
            />
         </b-form-group>
         <hr>
         <b-button
            v-b-tooltip.hover.top="'Simpan'"
            variant="primary"
            type="button"
            class="float-right"
            :disabled="isLoading"
            @click.prevent="onSave"
         >
            <b-spinner v-if="isLoading" small />Import
         </b-button>
      </b-modal>

      <ScrapLogModal
         v-model="scrapLogVisible"
         :nib="scrapNib"
         @done="onScrapDone(scrapNib)"
      />

      <ScrapConfigModal v-model="scrapConfigVisible" />

      <sweet-modal ref="modalPdf" modal-theme="light" overlay-theme="dark" width="80%">
         <div style="height: 70vh;">
            <vue-pdf-app :pdf="pdf" />
         </div>
      </sweet-modal>
   </div>
</template>

<style scoped>
.borderless>tr>td {
   border: none;
   padding: 0em;
}

table>tbody>tr>td>span>hr {
   margin-top: 0rem;
   margin-bottom: 0rem;
}

.nowrap {
   white-space: nowrap;
}

.kbli-row {
   display: flex;
   justify-content: space-between;
   align-items: center;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
